import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useBestPriceHintStateOpener = () => {
  return useOpenedStateManager('BEST_PRICE_HINT_FLYOUT_STATE_OPENER');
};
